const { WEB_VITALS } = require('../../constants/initiatives');
const { trackMetric, sendMetrics, getMetricsCollected } = require('../collector');
const { subscribe } = require('../subscriptions');

const getRequestIdleCallback = window.requestIdleCallback || (callback => setTimeout(callback, 200));

const eventName = 'webVitalsEvent';
let subscribedToPageUnload = false;
const subscribeToPageUnload = (settings) => {
  const webVitalsEventHandler = () => {
    if (window.document.visibilityState === 'hidden') {
      sendMetrics({ id: WEB_VITALS }, settings, getMetricsCollected());

      window.document.removeEventListener(eventName, webVitalsEventHandler);
      subscribedToPageUnload = false;
    }
  };

  if (!subscribedToPageUnload) {
    // TODO - listen to pagehide on safari? https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
    window.document.addEventListener(eventName, webVitalsEventHandler);
    subscribedToPageUnload = true;
  }

  const visibilityChangeHandler = () => {
    const event = new window.Event(eventName);
    window.document.dispatchEvent(event);
  };
  window.document.addEventListener('visibilitychange', visibilityChangeHandler);
};

const setWebVitalsHandler = (commandData, settings) => {
  commandData.forEach((data) => {
    trackMetric(data.metric, data.value);
  });

  subscribeToPageUnload(settings);
};

const monitor = (settings) => {
  subscribe(WEB_VITALS, (commandData) => {
    if (commandData) {
      getRequestIdleCallback(() => setWebVitalsHandler(commandData, settings));
    }
  });
};

module.exports = monitor;
